import { MappedLink } from "@iewc/Services/CustomCategoryService";
import { CustomCategoriesStateType } from "@iewc/Store/State/Categories/CategoriesState";
import createTypedReducer from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

const initialState: CustomCategoriesStateType = {
    categories: [],
};

export const customCategoriesReducer = createTypedReducer(initialState, {
    "Data/Categories/LoadCustomCategories": (
        draft: Draft<CustomCategoriesStateType>,
        { categories }: { categories: [] },
    ) => {
        return {
            ...draft,
            ...categories,
        };
    },
});
